import classNames from "classnames";
import React from "react";

export default function Textarea({
  name,
  label,
  register,
  required,
  color,
  autocomplete,
}) {
  let textColor,
    borderColor,
    borderColorHover,
    borderColorActive,
    borderColorActiveHover,
    focusColor;
  if ((color = "light")) {
    textColor = "text-green-1";
    borderColor = "border-green-1";
    borderColorHover = "hover:border-green-2";
    borderColorActive = "active:border-green-2";
    borderColorActiveHover = "active:hover:border-green-3";
    focusColor = "focus:border-green-2";
  } else {
    textColor = "text-green-1";
    borderColor = "border-green-1";
    borderColorHover = "hover:border-green-2";
    borderColorActive = "active:border-green-2";
    borderColorActiveHover = "active:hover:border-green-3";
    focusColor = "focus:border-green-2";
  }

  return (
    <div className="flex flex-col">
      <label className={classNames(textColor, "mb-2 uppercase tracking-tight")}>
        {label}
        {required && "*"}
      </label>
      <textarea
        rows="8"
        autocomplete={autocomplete}
        className={classNames(
          borderColor,
          borderColorHover,
          borderColorActive,
          borderColorActiveHover,
          focusColor,
          "border-b-[1.5px] bg-transparent text-green-3 outline-none lg:h-[190px] 2xl:text-xl",
        )}
        {...register(name, { required })}
      />
    </div>
  );
}
